/**
 * Available store-filter facets for a category — the distinct values a
 * describe/save store filter can pick from (see StoreFilter). Category-scoped
 * (by id) so the variant-restriction UI can populate its pickers without needing
 * retailer/category codes.
 */
export const RouteGetMerchflowStoreFacets = "/merchflow/store-facets";

export interface ParamsGetMerchflowStoreFacets {
  category_id: string;
}

/** Per-store filterable attributes, so the UI can count how many stores a filter selects. */
export interface StoreFacetStore {
  code: string;
  bay_size: number;
  state: string;
  cluster: string;
  section_height: number;
  section_width: number;
}

export interface ResponseGetMerchflowStoreFacets {
  bay_sizes: number[];
  states: string[];
  clusters: string[];
  section_heights: number[];
  section_widths: number[];
  stores: StoreFacetStore[];
}
